"use client";

import { useRouter } from "@bprogress/next";
import { useGailDock } from "@/contexts/chat/GailDockContext";
import { useStableCallback } from "@/hooks/useStableCallback";
import {useGailLauncherShortcut} from "@/hooks/useGailLauncherShortcut";
import GailTopbarButton from "./GailTopbarButton";

/** Reuse the page's existing chat instead of mounting a competing conversation sheet. */
export default function GailExistingChatEntry() {
  const { isDockAvailable, isOpen, toggleDock } = useGailDock();
  const router = useRouter();
  const activate = useStableCallback(() => {
    if (isDockAvailable) toggleDock();
    else router.push("/gailgpt");
  });

  useGailLauncherShortcut(activate);

  return <GailTopbarButton chatOpen={isDockAvailable && isOpen} onClick={activate} />;
}
